App.factory('restmodMixin', ['restmod', 'authService', '$state', 'responseHelper', 'cfpLoadingBar', '$location', (restmod, authService, $state, responseHelper, cfpLoadingBar, $location) => restmod.mixin({
    $hooks: {
        'before-request'(_req) {
            //console.log(_req, 'before-req')
            //var host = $location.host()
            //host = host.split('.')
            //console.log(host.length < 3)
            //if (host.length < 3) {
            //    host = ""
            //}
            //else {
            //    host = host[0] + "."
            //}
            const subdomain = authService.getUserSubdomain()
            const auth = authService.getAuth()
            const impersonationSessionId = authService.impersonationSessionId()

            cfpLoadingBar.includeBar = true
            cfpLoadingBar.includeSpinner = true
            let headers
            if (auth !== undefined) {
                // cfpLoadingBar.start()
                headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.Nexhealth+json; version=1',
                    'Authorization': authService.getUserAuthorizationHeader(),
                    'If-None-Match' : 's'
                }
                //_req.url = _req.url.replace("https://", "https://" + host + ".")
                //_req.url = _req.url.replace("http://", "http://" + host + ".")
                //console.log(_req.url)
            } else {
                headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.Nexhealth+json; version=1'
                }
            }
            // TODO remove after ImpersonationSession retirement
            if (impersonationSessionId !== undefined) {
                headers['Nex-ImpersonationSessionId'] = impersonationSessionId
            }
            const params = {subdomain}
            _req.params = angular.extend(params, _req.params)
            _req.headers = angular.extend(headers)
            _req.timeout = 2 * 60 * 1000 // 2 minutes

            //console.log(_req, 'after-extend')
        },
        'after-feed'(_resp) {
            // cfpLoadingBar.complete()
            //responseHelper.redirectOrToastOnResp(_resp)
        },
        'after-request-error'(_resp) {
            /// cfpLoadingBar.complete()
            responseHelper.checkError(_resp)
        }
    }
})])
